import React from 'react'

const Section = (props) => {
    const {width, height} = props.settings;

    const svgStyles = {
        width: '100vw',
        height: '' + Math.floor(height/width*100) + 'vw'
    }

    return (
        <section className="image-section">
            <img src={process.env.CMS_HOST + "/" + props.settings.image.path} alt="" />
        </section>  
    )
}

export default Section


// WEBPACK FOOTER //
// ./src/components/ImageSection.js